export default __webpack_public_path__ + "static/media/1-14@2x.69f903bc.png";